import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import ErpPosReportTransactionV1Page from "./ErpPosReportTransactionV1Page";
import ErpPosReportTransactionV2Page from "./ErpPosReportTransactionV2Page";

function ErpPosReportTransaction() {
  const [isPosReportTransfer, setIsPosReportTransfer] = useState(false);
  const [isPosReportTransferV2, setIsPosReportTransferV2] = useState(false);
  useEffect(() => {
    RequestHandler.get("/TenantErpProgram/GetByTenant").then((response) => {
      if (response?.isPosReportTransfer) {
        setIsPosReportTransfer(true);
      } else {
        setIsPosReportTransferV2(true);
      }
    });
  }, []);

  return (
    <>
      {isPosReportTransfer && <ErpPosReportTransactionV1Page />}
      {isPosReportTransferV2 && <ErpPosReportTransactionV2Page />}
    </>
  );
}

export default ErpPosReportTransaction;
